import { createActionRoute, createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const followProjectActionRoute: SiteHomePageRoute = createSiteRoute(
	createActionRoute({
		exact: true,
		name: 'followProjectAction',
		path: '/project/:key/:action(follow|unfollow)',
	}),
);
